var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m19.556,19.556H2.444V2.444h8.556V0H2.444C1.09422,0,0,1.09422,0,2.444v17.112c0,1.34978,1.09422,2.444,2.444,2.444h17.112c1.34796-.00439,2.43961-1.09604,2.444-2.444v-8.556h-2.444v8.556ZM13.444,0v2.444h4.388L5.818,14.459l1.723,1.723,12.015-12.014v4.388h2.444V0h-8.556Z",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNew);
export default __webpack_public_path__ + "static/media/open-new.27454f6ed113e3fbe446a473b5e61a68.svg";
export { ForwardRef as ReactComponent };